export { default as aws } from '@/service/coa/csp/aws';
export { default as azure } from '@/service/coa/csp/azure';
export { default as gcp } from '@/service/coa/csp/gcp';



// WEBPACK FOOTER //
// ./src/service/coa/csp/index.js